import React        from 'react';
import Root         from './pages/Root';
import { connect }  from 'react-redux';
import { Dispatch } from "redux";
import './App.css';

const RECORD_ENTRY_SAGA = () => ({
  type: 'RECORD_ENTRY_SAGA'
});

type ActionTypes = { type: string }
type AppProps    = { recordEntry: () => void; }


const App: React.FC<AppProps> = ({ recordEntry }) => {

  const [recordEntryOnce, setRecordEntryOnce] = React.useState(false);

  const recordEntryCB = React.useCallback(() => {
    if ( !recordEntryOnce ) {
      setRecordEntryOnce(true)
      recordEntry();
    }
  },[recordEntryOnce, recordEntry])

  React.useEffect(() => {
    recordEntryCB();
  },[recordEntryCB])

  return (
       <Root/>
  );
}


const mapStateToProps = () => {
  return {}
};

const mapDispatchToProps = (dispatch: Dispatch<ActionTypes>) => ({
   recordEntry: () => dispatch(RECORD_ENTRY_SAGA())
});

export default connect(mapStateToProps, mapDispatchToProps)(App);






////@types/react-redux react-redux redux redux-saga axios


//    "homepage": "https://www.yisumatica.org.il/flash-upload/uova",


//    "homepage": "https://www.yisumatica.org.il/flash-upload/i-see-math/uova",




//http://uova.s3-website.us-east-2.amazonaws.com